import React from "react";
import { SITE } from "@/lib/site";

export default function WhatsAppFab() {
  const number = "919449982902"; // +91 94499 82902
  const message = encodeURIComponent(
    `Hi Wateriia! I'd like to place an order for clean drinking water in ${SITE.city}.`
  );
  const href = `https://wa.me/${number}?text=${message}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Order on WhatsApp"
      className="fixed z-40 bottom-6 right-6 group"
    >
      <span className="relative inline-flex">
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
        <span className="relative inline-flex items-center gap-2 pl-3 pr-4 py-3 rounded-full bg-[#25D366] text-white shadow-[0_18px_40px_-12px_rgba(37,211,102,0.6)] hover:bg-[#1ebe57] transition-transform group-hover:-translate-y-0.5">
          <svg width="22" height="22" viewBox="0 0 32 32" fill="currentColor" aria-hidden>
            <path d="M19.11 17.21c-.3-.15-1.79-.88-2.07-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.78-1.67-2.08-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.07-.15-.68-1.64-.93-2.24-.24-.58-.49-.5-.68-.51l-.58-.01c-.2 0-.53.07-.81.38-.28.3-1.06 1.04-1.06 2.54 0 1.5 1.09 2.95 1.24 3.15.15.2 2.14 3.27 5.18 4.59.72.31 1.29.5 1.73.64.73.23 1.4.2 1.92.12.59-.09 1.79-.73 2.04-1.43.25-.7.25-1.3.18-1.43-.07-.13-.27-.2-.57-.35zM16.04 4C9.97 4 5.05 8.92 5.05 14.99c0 1.95.51 3.85 1.49 5.52L5 27l6.65-1.74a10.97 10.97 0 0 0 5.39 1.4h.01c6.07 0 10.99-4.92 10.99-10.99S22.11 4 16.04 4zm0 19.96h-.01a9.07 9.07 0 0 1-4.62-1.27l-.33-.2-3.95 1.04 1.05-3.85-.21-.34a9.07 9.07 0 0 1-1.39-4.85c0-5.01 4.08-9.09 9.1-9.09 2.43 0 4.71.95 6.43 2.66a9.04 9.04 0 0 1 2.66 6.44c0 5.01-4.08 9.46-8.74 9.46z"/>
          </svg>
          <span className="hidden sm:inline text-sm font-semibold whitespace-nowrap">Order on WhatsApp</span>
        </span>
      </span>
    </a>
  );
}
